import React from "react";

/**
 * Suspense fallback for lazily loaded route chunks (see src/AppRoutes.jsx).
 * Shown only during client-side navigation while a page chunk downloads — never
 * on a prerendered first load, where React keeps the static HTML in place until
 * the chunk hydrates. Reserves height so the footer does not jump up.
 */
export const RouteFallback = () => (
  <div className="min-h-[60vh]" role="status" aria-live="polite" aria-label="Loading page" data-testid="route-loading" />
);
